module.exports = __webpack_public_path__ + "static/media/logs.7935a8c1.svg";